__turbopack_context__.v({
  "email-verify": "EmailVerify-module-scss-module__lBDF7W__email-verify",
  "resend-button": "EmailVerify-module-scss-module__lBDF7W__resend-button",
  "resend-container": "EmailVerify-module-scss-module__lBDF7W__resend-container",
  "resend-text": "EmailVerify-module-scss-module__lBDF7W__resend-text",
});
